import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { images } from "../../config/images";
import { siteContent } from "../../content/siteContent";
import { ResponsiveImage } from "./ResponsiveImage";
import { trackCtaClick } from "../../lib/analytics";

export function HomeHeader() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const { navigation } = siteContent;

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 16);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (!isMenuOpen) return;

    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") setIsMenuOpen(false);
    };

    window.addEventListener("keydown", closeOnEscape);
    return () => window.removeEventListener("keydown", closeOnEscape);
  }, [isMenuOpen]);

  return (
    <header
      className={`home-header${isScrolled ? " home-header--scrolled" : ""}${
        isMenuOpen ? " home-header--menu-open" : ""
      }`}
    >
      <div className="home-header__inner">
        <Link
          className="home-header__brand"
          to="/"
          aria-label="Evolution by Corina, ir al inicio"
          onClick={() => setIsMenuOpen(false)}
        >
          <ResponsiveImage image={images.logo} className="home-header__logo" eager />
        </Link>

        <nav className="home-header__desktop-nav" aria-label={navigation.ariaLabel}>
          {navigation.items.map((item) => (
            <a key={item.href} href={item.href}>
              {item.label}
            </a>
          ))}
        </nav>

        <Link className="home-button home-button--compact home-header__cta" to={navigation.cta.href}
          reloadDocument onClick={() => trackCtaClick("header")}>
          {navigation.cta.label}
        </Link>

        <button
          className="home-menu-button"
          type="button"
          aria-expanded={isMenuOpen}
          aria-controls="home-mobile-navigation"
          aria-label={isMenuOpen ? navigation.menuCloseLabel : navigation.menuOpenLabel}
          onClick={() => setIsMenuOpen((open) => !open)}
        >
          <span aria-hidden="true" />
          <span aria-hidden="true" />
        </button>
      </div>

      <nav
        id="home-mobile-navigation"
        className="home-mobile-nav"
        aria-label="Navegación móvil"
        aria-hidden={!isMenuOpen}
      >
        <div className="home-mobile-nav__inner">
          {navigation.items.map((item) => (
            <a key={item.href} href={item.href} onClick={() => setIsMenuOpen(false)}>
              {item.label}
            </a>
          ))}
          <Link to={navigation.cta.href} reloadDocument onClick={() => {
            trackCtaClick("mobile_menu");
            setIsMenuOpen(false);
          }}>
            {navigation.cta.label}
          </Link>
        </div>
      </nav>
    </header>
  );
}
